// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"336":"1751480d","376":"555fda12","622":"bd3dbcff","896":"136787a1"}[chunkId] + ".chunk.css";
};